import userDlg from "./userDlg";
import memberDlg from "./memberDlg";
import roomDlgMul from "./roomDlgMul";
import roomDlg from "./roomDlg";
import subjectDlg from "./subjectDlg";
import communityDlgMul from "./communityDlgMul";
import adPosDlgMul from "./adPosDlgMul";
import garageDlgMul from "./garageDlgMul";
import parkingDlgMul from "./parkingDlgMul";

const communityMan = {
  namespaced: true,
  modules: {
    userDlg,
    memberDlg,
    roomDlgMul,
    roomDlg,
    subjectDlg,
    communityDlgMul,
    adPosDlgMul,
    garageDlgMul,
    parkingDlgMul
  }
};

export default communityMan;
